export default (_, t) => {
  return {
    fields: [
      {
        as: 'color',
        label: t('propsEditor.backgroundColor'),
        name: 'fill',
        descriptions: [t('propsEditor.rectBackgroundColorTip')],
      },
    ],
  };
};
